import { FC, useState } from 'react';
import { GET_MEDIA_BY_FLOC } from '../../../graph-queries/tar/media';
import { useQuery } from '@apollo/client';
import classes from './MediaGallaryMini.module.scss';
import { Button, Spinner } from '@bphxd/ds-core-react';
import { Right24 } from '@bphxd/ds-core-react/lib/icons';

const MAX_COUNT = 5;

const MediaGallaryMini: FC<{ floc: string }> = ({ floc }) => {
  const [showAll, setShowAll] = useState(false);
  const { data, loading } = useQuery(GET_MEDIA_BY_FLOC, {
    variables: { floc },
  });

  return (
    <div className={classes.root}>
      <div className={classes.title}>Media Gallery</div>

      {loading ? (
        <Spinner />
      ) : (
        <div className={classes.content}>
          <div className={classes.files}>
            {(data?.mediaMetadataByFloc || [])
              .slice()
              .sort((b, a) => a.mediaId - b.mediaId)
              .filter((_, index) => showAll || index < MAX_COUNT)
              .map((metadata) => (
                <div key={metadata.mediaId} className={classes.file}>
                  <a href={metadata.url} target="_blank" rel="noreferrer">
                    <img src={metadata.url} alt={metadata.fileName} />
                  </a>
                </div>
              ))}
          </div>
          {showAll || (
            <div className={classes.all}>
              <Button
                level="quartenary"
                Icon={Right24}
                iconPosition="end"
                onClick={() => setShowAll(true)}
              >
                View All
              </Button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default MediaGallaryMini;
